module.exports = __webpack_public_path__ + "img/bg-l.b3e267fb.png";